module.exports = __webpack_public_path__ + "img/util-cold_water.353a1daa.svg";